<template>
  <div>
    <!-- <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu đăng ký combo bán hàng</h1>
    </div> -->
    <div class="p-10 card pt-15 mt-3">
      <div class="card-header mb-2">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input style="border-radius: 4px" v-model="search.keyword" placeholder="Từ khoá" />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.agentId" :options="dataAgent" placeholder="Đối tác"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionIds"
              :options="dataConfigRegion"
              placeholder="Vùng"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.paymentStatus"
              :options="optionPaymentStatus"
              placeholder="Trạng thái thanh toán"
            >
            </Select2>
          </div>

          <div class="form-group">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="resetFilters"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-2">
              <div class="status-summary-compact mb-0" style="position: relative">
                <div>
                  <!-- Tổng số -->
                  <div class="total-item" v-if="pagination?.total">
                    <span class="custom-label">Tổng:</span>
                    <span class="custom-label text-primary">{{
                      pagination?.total | formatNumberVN
                    }}</span>
                  </div>

                  <!-- Trạng thái chung -->
                  <div class="status-group" v-if="statusObj?.listCountStatus">
                    <span class="custom-label"> Trạng thái: </span>
                    <div class="status-items">
                      <span
                        v-for="(item, index) in statusObj.listCountStatus"
                        :key="index"
                        class="status-item"
                      >
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>

                  <!-- Trạng thái CKS -->
                  <div class="status-group" v-if="statusObj?.listCountSignatureStatus">
                    <span class="custom-label"> Trạng thái CKS: </span>
                    <div class="status-items">
                      <span
                        v-for="(item, index) in statusObj.listCountSignatureStatus"
                        :key="index"
                        class="status-item"
                      >
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>

                  <!-- Trạng thái thuế -->
                  <div class="status-group" v-if="statusObj?.listCountTaxStatus">
                    <span class="custom-label"> Trạng thái Thuế: </span>
                    <div class="status-items">
                      <span
                        v-for="(item, index) in statusObj.listCountTaxStatus"
                        :key="index"
                        class="status-item"
                      >
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <b-button
                  size="md"
                  style="position: absolute; right: 0; bottom: 0"
                  variant="primary"
                  @click="exportExcel"
                >
                  <i class="bx bx-download"></i>
                  {{ loadingExport ? 'Đang tải...' : 'Tải xuống File' }}
                </b-button>
              </div>
            </div>
            <b-overlay :show="loading" opacity="0.6" rounded="sm">
              <b-table
                sticky-header
                hover
                responsive
                :items="list"
                :fields="tableFields"
                :fixed="true"
                :bordered="true"
              >
                <template #cell(index)="data">
                  {{ getIndex(data.index) }}
                </template>
                <template #empty>
                  <div class="text-center text-black my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>

                <template #cell(createdDate)="data">
                  <p v-if="data.item.createdDate">
                    {{ data.item.createdDate | formatDate('DD/MM/YYYY HH:mm') }}
                  </p>
                </template>

                <template #cell(merchantName)="data">
                  <p>Tên: {{ data.item.merchantName }}</p>
                  <p>MST: {{ data.item.businessRegistrationNumber }}</p>
                </template>
                <template #cell(status)="data">
                  <span class="badge" :class="getStatusBadgeClass(data.item.status)">
                    {{ data.item.statusStr || data.item.status }}
                  </span>
                </template>
                <template #cell(digitalSignatureRegistrationStatusStr)="data">
                  <div
                    v-if="data.item.digitalSignatureRegistrationStatusStr"
                    class="badge"
                    :class="
                      getDigitalSignatureRegistrationStatus(
                        data.item.digitalSignatureRegistrationStatus
                      )
                    "
                  >
                    {{
                      data.item.digitalSignatureRegistrationStatusStr ||
                      data.item.digitalSignatureRegistrationStatus
                    }}
                  </div>
                </template>
                <template #cell(taxAuthorityVerifyStatusStr)="data">
                  <div
                    v-if="data.item?.taxAuthorityVerifyStatusStr"
                    class="badge"
                    :class="getTaxAuthorityVerifyStatus(data.item?.taxAuthorityVerifyStatus)"
                  >
                    {{
                      data.item?.taxAuthorityVerifyStatusStr || data.item?.taxAuthorityVerifyStatus
                    }}
                  </div>
                </template>

                <template #cell(paymentStatus)="data">
                  <span
                    v-if="data.item.paymentStatus"
                    class="badge"
                    :class="getPaymentStatusBadgeClass(data.item.paymentStatus)"
                  >
                    {{ data.item.paymentStatusStr || data.item.paymentStatus }}
                  </span>
                </template>

                <template #cell(action)="{ item }">
                  <button class="btn btn-info btn-sm mr-2" @click="viewDetails(item.id)">
                    Chi tiết
                  </button>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-4 fl-right"
        ></b-pagination>
      </div>
    </div>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { AgentService } from '@/services/agent.service'
  import { CommonService } from '@/services/common.service'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'

  const tableFields = [
    { key: 'index', label: 'STT' },
    { key: 'code', label: 'Mã yêu cầu' },
    { key: 'createdDate', label: 'Thời gian tạo' },
    { key: 'merchantName', label: 'Tên merchant' },
    { key: 'agentName', label: 'Đối tác' },
    {
      key: 'keeper.regionName',
      label: 'Vùng',
      tdAttr: {
        style: 'max-width: 200px;',
      },
    },
    // { key: 'businessRegistrationNumber', label: 'Mã số thuế' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'digitalSignatureRegistrationStatusStr', label: 'TT CKS' },
    { key: 'taxAuthorityVerifyStatusStr', label: 'TT TĐ Thuế' },
    { key: 'paymentStatus', label: 'Trạng thái thanh toán' },
    { key: 'reason', label: 'Ghi chú' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    name: 'ComboRegistrationList',
    components: {
      ModalExportNoti,
    },
    data() {
      return {
        localeData: Config.localeData,
        showAddModal: false,
        addLoading: false,
        newRequest: {
          merchantName: '',
          businessRegistrationNumber: '',
          agentName: '',
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        loading: false,
        showLoading: false,
        tableFields,
        optionStatus: Config.optionStatusCombo,
        optionPaymentStatus: Config.optionPaymentStatusCombo,
        list: [],
        search: {
          page: 1,
          limit: 20,
          countStatus: true,
        },
        pagination: {
          total: 1,
        },
        dataAgent: [],
        dataConfigRegion: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        statusObj: null,
        loadingExport: false,
      }
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    watch: {
      'search.limit': function () {
        this.fetchData()
      },
      'search.page': function () {
        this.fetchData()
      },
    },

    created() {
      // const { from, to } = this.$getLast7Days();
      // this.search.fromDate = from;
      // this.search.toDate = to;

      this.fetchData()
      this.getRegions()
      this.getAgents()
    },

    methods: {
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      async exportExcel() {
        try {
          this.loadingExport = true

          for (const key in this.search) {
            if (this.search[key] === '' || this.search[key] === null || this.search[key] === '0') {
              delete this.search[key]
            } else if (key === 'keyword' && typeof this.search.keyword === 'string') {
              this.search.keyword = this.search.keyword.trim()
            }
          }

          const body = {
            object: this.search,
            type: 'CNPS_AGENT_REQUEST_COMBO',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            await this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          this.showFailMx(`Lỗi: ${error.message}`)
        } finally {
          this.loadingExport = false
        }
      },
      getDigitalSignatureRegistrationStatus(status) {
        const map = Config.digitalSignatureRegistrationStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      getTaxAuthorityVerifyStatus(status) {
        const map = Config.taxAuthorityVerifyStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      transfromDate() {
        this.search.fromDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async getAgents() {
        const response = await AgentService.getListAgentPartner({ limit: 1000, page: 1 })
        if (response.code === 1000) {
          this.dataAgent =
            response.data.map(e => ({
              id: e.agentId,
              text: e.name,
            })) || []
        }
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion =
            data.data.map(e => ({
              id: e.id,
              text: e.name,
            })) || []
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },

      getStatusBadgeClass(status) {
        const map = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },

      getPaymentStatusBadgeClass(paymentStatus) {
        const map = this.optionPaymentStatus.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[paymentStatus] || 'badge-secondary'
      },

      async resetFilters() {
        this.search = {
          page: 1,
          limit: 20,
          countStatus: true,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      viewDetails(id) {
        this.$router.push(`/request-sales-combo-detail/${id}`)
      },

      async fetchData() {
        if (!this.loading) this.showLoading = true
        try {
          this.loading = true
          this.search.regionIds = this.search.regionIds ? [this.search.regionIds] : ''
          // Loại bỏ giá trị rỗng
          for (const key in this.search) {
            if (this.search[key] === '' || this.search[key] === null || this.search[key] === '0') {
              delete this.search[key]
            } else if (key === 'keyword' && typeof this.search.keyword === 'string') {
              this.search.keyword = this.search.keyword.trim()
            }
          }

          this.search.isMnpView = true

          const response = await ComboService.getList(this.search)
          if (response.code === 1000) {
            this.list = response.data || []
            this.pagination.total = response.totalPage.total || 0
            this.statusObj = response.meta?.metaData || []
          } else {
            this.list = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.error('Error fetching data:', error)
          this.list = []
          this.pagination.total = 0
        } finally {
          this.loading = false
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .status-summary-compact {
    /* background: #f8f9fa; */
    border-radius: 6px;
    /* padding: 12px; */
    /* border: 1px solid #e9ecef; */
  }

  .status-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 13px;
  }

  .total-item {
    display: flex;
    align-items: center;
    gap: 6px;
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    /* color: white; */
    /* padding: 6px 12px; */
    border-radius: 20px;
    font-weight: 500;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  }

  .total-item i {
    font-size: 14px;
  }

  .total-number {
    font-weight: 600;
    font-size: 14px;
    color: #0b62ab;
  }

  .status-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .status-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
    line-height: 12px;
  }

  .status-item {
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 12px;
    white-space: nowrap;
    border: 1px solid #007bff;
  }

  .status-item strong {
    font-weight: bold;
  }
</style>
